import { useApiMutation } from "./use-api-mutation";

export default function useTestAlerting(shopId: string) {
  return useApiMutation("post", "/shops/{shopId}/reporting/alerting/test", {
    notify: true,
    mapVariables: (email: string) => ({
      params: { path: { shopId } },
      body: { email },
    }),
  });
}
